import { AlertCircle, Zap } from 'lucide-react';
import { Card } from '../../ui/card';
import { Checkbox } from '../../ui/checkbox';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';

interface UrgentQuoteConfigProps {
  enabled: boolean;
  onToggle: (v: boolean) => void;
  price: number | null;
  onPriceChange: (v: number) => void;
  delay: number;
  onDelayChange: (v: number) => void;
}

export function UrgentQuoteConfig({ enabled, onToggle, price, onPriceChange, delay, onDelayChange }: UrgentQuoteConfigProps) {
  return (
    <Card className="p-4 mb-4">
      <div className="flex items-center gap-3 mb-4">
        <Checkbox id="enableUrgent" checked={enabled} onCheckedChange={onToggle} />
        <Label htmlFor="enableUrgent" className="cursor-pointer flex items-center gap-2"><Zap className="w-4 h-4 text-[#8E0B56]" /><span className="font-medium">Proposer une option "Devis urgent"</span></Label>
      </div>

      {enabled && (
        <div className="ml-7 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label htmlFor="urgentPrice">Prix (FCFA)</Label>
              <Input id="urgentPrice" type="number" value={price || ''} onChange={(e) => onPriceChange(parseInt(e.target.value) || 0)} placeholder="20000" />
            </div>
            <div>
              <Label htmlFor="urgentDelay">Délai (heures)</Label>
              <Input id="urgentDelay" type="number" value={delay} onChange={(e) => onDelayChange(parseInt(e.target.value) || 24)} placeholder="24" />
            </div>
          </div>
          <div className="bg-[rgba(142,11,86,0.05)] border border-[rgba(142,11,86,0.2)] rounded-lg p-3">
            <div className="flex items-start gap-2">
              <AlertCircle className="w-4 h-4 text-[#8E0B56] mt-0.5" />
              <p className="text-sm text-[#00303c]">Le client paiera <strong className="text-[#8E0B56]">{price?.toLocaleString()} FCFA</strong> pour un devis sous <strong className="text-[#8E0B56]">{delay}h</strong>.</p>
            </div>
          </div>
        </div>
      )}
    </Card>
  );
}
